var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine59(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 77",
    overflow: "scroll",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    fill: "#DC9600",
    width: 120,
    height: 77
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.1361847,69.5891037c-6.9419613,0-12.2753468-1.5238266-16.8470287-4.3176422l4.8255138-9.3120346 c3.3016891,2.2853241,6.6881275,3.8095627,11.3443527,3.8095627s10.4974823-2.7938194,10.4974823-9.8205261 c0-4.3176422-2.8783607-10.2434464-13.8839226-10.412941c-3.3862305,0-7.3652897-0.0847511-9.3124466-0.0847511 l2.3704872-31.0695305h31.4083176v9.9896107H32.0356903l-0.8466606,11.3445568 c0.3385811,0,1.1007004,0.0843353,1.6931152,0.0843353c16.3391571,0.7619133,22.9425354,9.9896126,22.9425354,18.9634743 C55.8246803,60.192318,46.7662735,69.5891037,33.1361847,69.5891037z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7195663,69.7585983c-3.3866501,0-6.4342957-0.4233322-8.9738693-1.0161591l1.8624115-10.1586952 c1.6085739,0.677166,4.7409668,1.4390755,8.2119522,1.4390755c8.3810349,0,14.4763336-6.6877136,15.322998-18.7096405 c-2.0319061,1.7780724-5.9262161,4.0638084-12.3600998,4.0638084c-9.9048615,0-17.8629799-6.518631-17.8629799-17.6938953 c0-11.9365597,7.9581184-20.7411346,20.4873009-20.7411346c16.3391571,0,22.1806183,11.3443518,22.1806183,27.1754265 C104.5878983,54.8589325,94.8521271,69.7585983,75.7195663,69.7585983z M82.9153595,16.3391533 c-5.9262161,0-8.9738693,4.8253078-8.9738693,9.9896107c0,5.5876331,3.7248154,9.6510296,9.6510315,9.6510296 c3.8095627,0,6.8572083-1.4390755,8.0424576-3.301899c0.6775742-1.0153313,0.6775742-3.3858166,0.6775742-5.163887 C92.3125534,21.8416252,89.0106583,16.3391533,82.9153595,16.3391533z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine59);
export default __webpack_public_path__ + "static/media/line-59.75337a4fac28a665a07cf2187e26a4bb.svg";
export { ForwardRef as ReactComponent };